import Relay from 'react-relay';

export default class EnqueueMonthlyTariffClickUpJob extends Relay.Mutation {
    static propTypes = {};

    getMutation() {
        return Relay.QL`mutation { enqueueMonthlyTariffClickUpJob }`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on EnqueueMonthlyTariffClickUpJobPayload {
                job {
                    id,
                    realId,
                    name
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            organisationId: this.props.organisationId,
            targetMonth: this.props.targetMonth || 'next', // 'current' or 'next'
        };
    }
}


